module.exports = __webpack_public_path__ + "static/media/matilde-hat-brazil-bored.c65bd433.png";